export class DeletarCategoriaFinanceiraRequest {
    idsCategorias: number[];
    idCategoriaMigracao?: number;
}
